import { useDispatch } from "react-redux";
import { CHECKOUT_PAGES_ACTION_TYPES } from "../constants/CheckoutPagesReducer";

const useSetIsExpressInterestProcessing = () => {
    const dispatch = useDispatch();

    const setIsExpressInterestProcessing = (isLoading: boolean) => {
        dispatch({
            type: CHECKOUT_PAGES_ACTION_TYPES.SET_IS_EXPRESS_INTEREST_PROCESSING,
            payload: {
                isExpressInterestProcessing: isLoading,
            },
        });
    };

    return {
        setIsExpressInterestProcessing,
    };
};

export default useSetIsExpressInterestProcessing;
